import { useTranslation } from "react-i18next";
import { useGetImageHistory } from "../../hooks/useImages";
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  DialogTrigger,
  makeStyles,
  Spinner,
} from "@fluentui/react-components";
import ImageHistoryDataGrid from "./ImageHistoryDataGrid";
import { useState } from "react";

const useStyles = makeStyles({
  dialogSurface: {
    minWidth: "1000px",
  },
  content: {
    display: "flex",
    flexDirection: "column",
  },
});

interface ImageHistoryDialogProps {
  imageId: string;
}

export const ImageHistoryDialog = (props: ImageHistoryDialogProps) => {
  const { imageId } = props;
  const { data: images, isLoading: loadingHistory } =
    useGetImageHistory(imageId);
  const { t } = useTranslation();

  const classes = useStyles();
  const [open, setOpen] = useState<boolean>(false);

  return (
    <Dialog open={open}>
      <DialogTrigger disableButtonEnhancement>
        <Button onClick={() => setOpen(true)}>{t("showHistory")}</Button>
      </DialogTrigger>
      <DialogSurface
        className={classes.dialogSurface}
        aria-describedby={undefined}
      >
        <DialogBody>
          <DialogTitle>{t("history")}</DialogTitle>
          <DialogContent>
            {loadingHistory && <Spinner />}
            {!loadingHistory && images && (
              <ImageHistoryDataGrid images={images} />
            )}
          </DialogContent>
          <DialogActions>
            <DialogTrigger disableButtonEnhancement>
              <Button onClick={() => setOpen(false)} appearance="secondary">
                {t("close")}
              </Button>
            </DialogTrigger>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default ImageHistoryDialog;
